// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation } from "redux-query-react";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { DatapointsFiltersRequestToJSON, DatapointsFiltersResponseFromJSON, } from '../models';
/**
 * Retrieve datapoints filters values with a POST to avoid GETs with bodies
 * Retrieve datapoints details
 */
export function postDatapointsFiltersRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/datapoints/filters` + queryString,
        meta,
        update: requestConfig.update || {
            DatapointsFilters: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: DatapointsFiltersRequestToJSON(requestParameters.datapointsFiltersRequest),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = DatapointsFiltersResponseFromJSON(body);
            if (body.id) {
                return { DatapointsFilters: { [objResponse.id]: objResponse } };
            }
            if (body.data && body.total && requestConfig.queryKey) {
                return { DatapointsFilters: { [requestConfig.queryKey]: objResponse } };
            }
            return {};
        }
    };
    config.queryKey = requestConfig.queryKey || `PostDatapointsFilters-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Retrieve datapoints filters values with a POST to avoid GETs with bodies
* Retrieve datapoints details
*/
/**
 * Mutation hook to upsert an DatapointsFiltersResponse
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an DatapointsFiltersResponse
 */
export const usePostDatapointsFilters = (customQueryConfig) => {
    return useMutation((datapointsFiltersRequest, customQueryParam) => postDatapointsFiltersRaw({ datapointsFiltersRequest }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postDatapointsFilters(requestParameters, requestConfig) {
    return postDatapointsFiltersRaw(requestParameters, requestConfig);
}
